export default "__VITE_ASSET__0f68b644__"